import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Typography from "../components/Typography";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    backgroundColor: theme.palette.secondary.light,
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: "flex",
  },
}));

export default function AppFooter() {
  const classes = useStyles();

  return (
    <Typography component="footer" className={classes.root}>
      <Container className={classes.container}>
        <Grid container spacing={5}>
          <Grid item xs={6} sm={4} md={3}></Grid>
          <Grid item xs={6} sm={4} md={2}></Grid>
          <Grid item xs={6} sm={8} md={4}>
            <Typography variant="h6" marked="center" gutterBottom>
              @ballog2021
            </Typography>
          </Grid>
          <Grid item></Grid>
        </Grid>
      </Container>
    </Typography>
  );
}
